
export enum CastPositions {
    any = 0,
    first = 1,
    second = 2,
    third = 3,

}
/**
 * CastSelectionPlace defines cast selections position.
 * @typedef RacingEventInfo
 * @type {Object}
 * @property {lineId} ID of the line
 * @property {position} position of the line
 **/
export class CastSelectionPlace {
    lineId: string;
    position: CastPositions;

    constructor(source : CastSelectionPlace)
    {
        this.lineId = source.lineId;
        this.position = source.position;
    }

    static getArrayOfPosition(isTricast: boolean) {
        let CastPositionsArray: number[] = [CastPositions.first,
        CastPositions.second
        ];
        if (isTricast) {
            CastPositionsArray.push(CastPositions.third);
        }
        CastPositionsArray.push(CastPositions.any);
        return CastPositionsArray;
    }
}